import { createFileRoute } from '@tanstack/react-router';
import DashboardLayout from 'containers/Dashboard/DashboardLayout';
import { prefetchDashboardData } from '../../-utils/loaders';

export const Route = createFileRoute('/_authenticated/dashboard')({
  loader: ({ context }) => prefetchDashboardData(context.queryClient),
  component: DashboardLayout,
});
